import Vue from 'vue'
import Vuex from 'vuex'
import partnerStore from './partnerStore'
import appStore from './appStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app: appStore,
    partner: partnerStore
  }
})
